@if (formJson && pagesAddedReadyToDisplay) {
  <ptl-form-as-json [formJson]="formJson"></ptl-form-as-json>
}
